import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import "./EnquirySearch.css";


export default function EnquirySearch() {
  const { mode } = useParams(); // "nric" | "item" | "name" | "ticket"
  const nav = useNavigate();
  const [value, setValue] = useState("");

  const label = {
    nric: "Enter NRIC",
    item: "Enter Item Description",
    name: "Enter Name (partial ok)",
    ticket: "Enter Ticket / Receipt No.",
  }[mode];

  const onNext = () => {
    const v = value.trim();
    if (!v) return;

    if (mode === "ticket") {
      nav(`/ticket/${encodeURIComponent(v)}`, { state: { from: { pathname: "/enquiry/ticket" } } });
      return;
    }

    if (mode === "name") {
      nav(`/enquiry/name/pick`, { state: { query: v } });
      return;
    }

    nav(`/enquiry/${mode}/months`, { state: { value: v } });
  };

  return (
    <div className="enquirySearch">
      <h2>{label}</h2>
      <input
        className="input"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && onNext()}
        autoFocus
        placeholder={label}
      />
      <div className="row">
        <button className="btn secondary" onClick={() => nav("/enquiry")}>Back</button>
        <button className="btn primary" onClick={onNext}>Next</button>
      </div>
    </div>
  );
}
